import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import "../../styles/TestimonialsSection/TestimonialsCard.scss";
import React from "react";
import { FaStar } from "react-icons/fa6";
import i18next from "i18next";
// Bank logo image import
const rectangle12 = "https://example.com/rectangle-12.png"; // Replace with actual image URL
export interface Testimonial {
  name: string;
  role: string;
  image?: string;
  rate: number;
  description: string;
}
const TestimonialCard: React.FC<{ testimonial: Testimonial }> = (props) => {
  const { testimonial } = props;
  // Array to render stars
  const stars = Array(testimonial.rate).fill(0);

  return (
    <Box>
      <Card variant="outlined" className="testimonial-card">
        <CardContent>
          {/* Star Rating */}
          <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
            {stars.map((_, index) => (
              <FaStar key={index} size={"1.2rem"} color="#DBA32C" />
            ))}
          </Stack>

          {/* Testimonial Text */}
          <Typography
            fontFamily={i18next.language === "ar" ? "Somar" : "DM Sans"}
            className="testimonial-description"
          >
            {testimonial.description}
          </Typography>

          {/* Author Information */}
          <Box sx={{ my: "1rem" }}>
            <Typography
              fontFamily={i18next.language === "ar" ? "Somar" : "DM Sans"}
              className="testimonial-Contact"
              variant="h6"
            >
              {testimonial.name}
            </Typography>

            <Typography
              fontFamily={i18next.language === "ar" ? "Somar" : "DM Sans"}
              variant="caption"
              color="#1b1b1b"
              sx={{
                fontSize: "0.9rem",
              }}
            >
              {testimonial.role}
            </Typography>
          </Box>

          {testimonial.image && (
            <Box
              component="img"
              src={rectangle12}
              alt="CIB Bank"
              sx={{
                display: "flex",
                justifyItems: "flex-end",
              }}
            />
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default TestimonialCard;
